import { render, staticRenderFns } from "./AuditLogs.vue?vue&type=template&id=0e556fb1"
import script from "./AuditLogs.vue?vue&type=script&lang=js"
export * from "./AuditLogs.vue?vue&type=script&lang=js"
import style0 from "./AuditLogs.vue?vue&type=style&index=0&id=0e556fb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports